import { memo } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
const BarChart = ({
  icon,
  title,
  data,
  legend,
  categories,
  xAxisTitle = "Month",
  yAxisTitle = "in kilolitres",
}) => {
  const colorSequence = ["#06513D", "#06513D", "#06513D"];
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  //console.log(isPermissionCompleted, "isPermissionCompleted");

  const barColors = categories.map((_, index) => colorSequence[index % 3]);

  const actualMax = Math.max(...(data.length > 0 ? data : [0]), 0);
  const visualMax = actualMax === 0 ? 100 : actualMax;
  const displayData = data.map((val) => Math.max(val, visualMax * 0.03));

  const chartOptions = {
    chart: {
      type: "bar",
      height: 140, // Adjusted to fit within ~223px total height
      toolbar: { show: false },
    },
    xaxis: {
      categories,
      title: {
        text: xAxisTitle,
        style: { fontSize: "10px", color: "#000", fontWeight: "normal" },
      },
      labels: {
        style: { fontSize: "10px", color: "#000", fontWeight: "normal" },
      },
      axisBorder: { show: true, color: "#000" },
    },
    yaxis: {
      title: {
        text: yAxisTitle,
        style: {
          fontSize: "10px",
          color: "#000",
          fontWeight: "normal",
          textAlign: "center",
          textAnchor: "middle",
        },
      },
      labels: {
        style: { fontSize: "10px", color: "#000", fontWeight: "normal" },
      },
      axisBorder: { show: true, color: "#000" },
      min: 0,
      max: actualMax === 0 ? 100 : Math.ceil(actualMax * 1.2),
    },
    grid: {
      yaxis: { lines: { show: false } },
      xaxis: { lines: { show: false } },
    },
    colors: barColors,
    plotOptions: {
      bar: {
        columnWidth: "40%",
        distributed: true,
        borderRadiusApplication: "end",
        borderRadius: 0,
        dataLabels: { position: "top" },
      },
    },
    fill: { opacity: 1 },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: "10px",
        colors: ["#06513D"],
      },
      formatter: function (val, { dataPointIndex }) {
        return data[dataPointIndex] !== undefined ? data[dataPointIndex] : val;
      },
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
    legend: { show: false },
    tooltip: {
      y: {
        formatter: function (val, { dataPointIndex }) {
          return data[dataPointIndex];
        },
      },
    },
  };

  const series = [{ name: legend, data: displayData }];

  return (
    <div className="bg-white rounded-lg w-full h-[223px] p-3 sm:p-4">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[#06513D] text-2xl sm:text-3xl flex-shrink-0">
          {icon}
        </span>
        <h2 className="font-bold capitalize text-[#06513D] text-sm sm:text-base">
          {title}
        </h2>
      </div>

      <div
        className={`w-full overflow-x-auto ${!isPermissionCompleted ? "blur-sm opacity-60 pointer-events-none" : ""}`}
      >
        <div className="min-w-[300px] sm:min-w-[400px] md:min-w-[500px] lg:min-w-[600px]">
          <Chart
            options={chartOptions}
            series={series}
            type="bar"
            height={140}
            width="100%"
          />
        </div>
      </div>
    </div>
  );
};

export default memo(BarChart);
